import { createFaqJsonLd } from '../../faq/createFaqJsonLd';
import { landingFaq } from '../../faq/faq';

export const homeSeo = {
  title: 'Gold & Silver Price API and MCP Server for AI Agents | GoldAPI.io',
  description: 'Access real-time and historical precious-metals prices through REST, WebSockets, and the GoldAPI MCP Server for ChatGPT, Claude, Codex, and other AI agents.',
  canonicalUrl: 'https://www.goldapi.io/',
  openGraph: {
    title: 'Gold & Silver Price API and MCP Server for AI Agents',
    description: 'Connect applications and AI agents to real-time and historical precious-metals prices through GoldAPI REST, WebSockets, and MCP.'
  },
  twitter: {
    title: 'GoldAPI MCP Server and Precious Metals API',
    description: 'Precious-metals market data for applications, ChatGPT, Claude, Codex, and other MCP-compatible AI agents.'
  }
};

export const createHomeStructuredData = () => ({
  '@context': 'https://schema.org',
  '@graph': [
    { '@type': 'Organization', '@id': 'https://www.goldapi.io/#organization', name: 'GoldAPI.io', url: 'https://www.goldapi.io/', logo: 'https://www.goldapi.io/logo192.png' },
    { '@type': 'WebSite', '@id': 'https://www.goldapi.io/#website', url: 'https://www.goldapi.io/', name: 'GoldAPI.io', publisher: { '@id': 'https://www.goldapi.io/#organization' } },
    {
      '@type': 'SoftwareApplication',
      '@id': 'https://www.goldapi.io/#application',
      name: 'GoldAPI.io',
      url: 'https://www.goldapi.io/',
      applicationCategory: 'DeveloperApplication',
      operatingSystem: 'Web',
      description: 'Free real-time and historical Gold, Silver, Platinum and Palladium spot prices REST JSON API with live feed data from FOREX and LBMA.',
      provider: { '@id': 'https://www.goldapi.io/#organization' },
      offers: [
        { '@type': 'Offer', name: 'Free Plan', price: '0', priceCurrency: 'USD' },
        { '@type': 'Offer', name: 'Pro Plan', price: process.env.REACT_APP_STRIPE_PLAN_PRICE || '99', priceCurrency: 'USD', priceSpecification: { '@type': 'UnitPriceSpecification', price: process.env.REACT_APP_STRIPE_PLAN_PRICE || '99', priceCurrency: 'USD', unitText: 'month' } },
        { '@type': 'Offer', name: 'Business Plan', price: process.env.REACT_APP_STRIPE_BUSINESS_MONTHLY_PRICE || '199', priceCurrency: 'USD', priceSpecification: { '@type': 'UnitPriceSpecification', price: process.env.REACT_APP_STRIPE_BUSINESS_MONTHLY_PRICE || '199', priceCurrency: 'USD', unitText: 'month' } }
      ],
      featureList: [
        'Real-time precious metals spot prices',
        'Historical LBMA AM Fix prices since 1968',
        'Prices for XAU, XAG, XPT and XPD',
        'Support for USD, EUR, INR, AED, KWD, EGP, SAR and other currencies',
        'Prices in ounces, grams and karat purity grades',
        'Remote MCP server for AI agents with OAuth and API-key authentication'
      ]
    },
    createFaqJsonLd(landingFaq)
  ]
});
